import { errors as checkoutErrors } from '@/errorCodes/checkout';

import type { ServiceError } from '@/lib/types';
import { formMessages } from '@/messages/forms';

import { commonErrorCodeMessages, type FormattedError } from './common';

export const serviceErrorCodeMessage = (
  error: FormattedError<ServiceError>,
) => {
  switch (error.code) {
    case 'REQUIRED':
      return formMessages.requiredField;
    case 'INVALID':
      switch (error.field) {
        case 'email':
          return checkoutErrors.invalidEmail;
        default:
          return formMessages.invalidField;
      }
    case 'PAYMENT_ERROR':
      return commonErrorCodeMessages.genericPaymentError;
    default:
      return commonErrorCodeMessages.unexpectedErrorOccurred;
  }
};
